import { computed } from "vue";
import store from ".";
import { AppModule } from './modules/appState';

/**
 * Состояние модуля AppModule
 * @returns 
 */
export const useAppState = () => {
  if (!store.hasModule('app')) store.registerModule('app', AppModule);

  return {
    isMobile: computed(() => store.state.app.isMobile),
    windowWidth: computed(() => store.state.app.windowWidth),
  };
};
